import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as roomRTC from "../../services/roomRTC";

import { Minimize2, Maximize2, Move } from "lucide-react";
import { motion } from "framer-motion";
import { useDrag } from "@use-gesture/react";
import ButtonLeave from "../Buttons/ButtonLeave";

const RoomListenersPanel = ({ isRoomHost, identity, usuarioId, roomId,
    isOnlyAudio, isOnlyCamera, isRoomListener }) => {
    const [isMinimized, setIsMinimized] = useState(false);
    const [position, setPosition] = useState({ x: 50, y: 50 });

    const bindDrag = useDrag(({ offset }) => {
        setPosition({ x: offset[0], y: offset[1] });
    });

    useEffect(() => {
        const effectAsync = async () => {
            if (isRoomListener) {
                await roomRTC.getInitialRoomConnection(isRoomHost, identity, usuarioId, roomId, isOnlyAudio, isOnlyCamera, isRoomListener);
            }
        };

        effectAsync();
    }, [isRoomListener]);

    return (isRoomListener) && (
        <motion.div
            {...bindDrag()}
            className="absolute bg-dark shadow-xl rounded-2xl cursor-grab active:cursor-grabbing"
            animate={{ height: isMinimized ? 56 : 140, width: 400 }}
            transition={{ type: "spring", stiffness: 100 }}
            style={{
                left: position.x,
                top: position.y,
                zIndex: 9000,
                position: "absolute",
            }}>

            <div className="flex justify-between items-center bg-gray-100 px-4 py-2 rounded-t-2xl cursor-pointer">
                <div className="row room_listeners_panel_menu">
                    <div className="col-6 text-start">
                        <Move size={20} className="cursor-move" />
                    </div>

                    <div className="col-6 text-end" onClick={() => setIsMinimized(!isMinimized)}>
                        {isMinimized ? <Maximize2 size={20} /> : <Minimize2 size={20} />}
                    </div>
                </div>
            </div>

            {!isMinimized && (
                <div className="p-4 room_listeners_panel_content">
                    <ButtonLeave />
                </div>
            )}
        </motion.div>
    );
}

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStoreToProps)(RoomListenersPanel);